/**
 * Maps Geotab group names to the drive type of a vehicle. The group names are what the
 * customer database uses today; change them here, not in the page logic.
 */
export type FuelType = "electric" | "diesel" | "cng" | "petrol";

export interface FuelTypeGroup {
  groupName: string;
  fuelType: FuelType;
}

export const FUEL_TYPE_GROUPS: readonly FuelTypeGroup[] = [
  { groupName: "Elektro", fuelType: "electric" },
  { groupName: "Diesel", fuelType: "diesel" },
  { groupName: "Erdgas", fuelType: "cng" },
  { groupName: "Benzin", fuelType: "petrol" },
];

/**
 * Geotab's built-in "Powertrain and Fuel Type" groups (fixed ids, names like "Diesel" that
 * collide with the customer's groups). They only count when no customer group applies.
 */
export const GEOTAB_POWERTRAIN_GROUP_FUEL_TYPES: Record<string, FuelType> = {
  GroupDieselId: "diesel",
  GroupGasolinePetrolId: "petrol",
  GroupCompressedNaturalGasId: "cng",
  GroupBatteryElectricVehicleId: "electric",
};

/**
 * Display unit per drive type. Geotab reports CNG consumption as a litre equivalent, so it is
 * shown as "l (CNG)" until the customer provides a density for a kg conversion (spec 12.2).
 */
export const FUEL_TYPE_UNITS: Record<FuelType, string> = {
  electric: "kWh",
  diesel: "l",
  cng: "l (CNG)",
  petrol: "l",
};
